import React, { useEffect, useState } from "react";
import "./CompletionCertificate.scss";
import { CircularProgress } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import allActions from "../../../redux/actions";
import moment from "moment";
import { soloProducts } from "../../../globalConstants";
import BadgesCertificatesDialogBox from "./BadgesCertificateDialogBox";

const CompletionCertificate = (props: any) => {
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const [certificateAvailability, setCertificateAvailability] = useState(false);
  const [loaderFlag, setLoaderFlag] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  
  const handleClose=()=> {
    setOpenDialog(false);
  }

  const downloadCertificate = () => {
    if ((certificateAvailability || sessionStorage.getItem("isDemoUser")) && allInfo.common.productID !== "") {
      const downloadCertificate = process.env.REACT_APP_FORGOTEMAILURL + "/getcertificate" || "";
      const downloadCertificateKey = process.env.REACT_APP_XAPIKEY || "";
      let part = "";
      if (allInfo.common.productID === "18") {
        const completedData = Object.values(allInfo.currentCourseDetails.data.Completed);
        completedData.forEach(function (completeData: any) {
          completeData.forEach(function (module: any) {
            if (module.ModuleName === props.cardData.name) part = module.ModuleId;
          });
        });
        getCertificate(downloadCertificate, allInfo, part, downloadCertificateKey, dispatch, setLoaderFlag);
      } else if(allInfo.common.productID === "25") {
        getCertificate(downloadCertificate, allInfo, props, downloadCertificateKey, dispatch, setLoaderFlag);
      } else if(soloProducts.filter((solo: any)=> solo === allInfo.common.productID).length > 0) {
        getCertificate(downloadCertificate, allInfo, props.part, downloadCertificateKey, dispatch, setLoaderFlag);
      } else {
        getCertificate(downloadCertificate, allInfo, props.partTitle, downloadCertificateKey, dispatch, setLoaderFlag);
      }
    }
  };
  
  useEffect(() => {
    if (!allInfo.peopleInformation.isLoading && !allInfo.tmsCourses.isLoading) {
      if (allInfo.peopleInformation.data && allInfo.tmsCourses.data) {
        const filteredSprintLevelLic = allInfo.peopleInformation.data.getpeopleInformation.license.filter((prod: any) => {
            return prod.productId === "18" || prod.productId === "20" || prod.productId === "21"|| prod.productId === "22"|| prod.productId === "23"|| prod.productId === "24" || prod.productId === "29";
          }
        );
        if (
          !allInfo.currentCourseDetails.isLoading &&
          !allInfo.currentCourseDetails.isFailed &&
          !allInfo.currentCourseDetails.data
        ) {
          const uuId = allInfo.common.luuId;
          let activeCourse = allInfo.tmsCourses.data.getTMSGetCourse.filter(
            (courseFilter: any) => courseFilter.status === "3" || courseFilter.status === "1"
          );
          let courseId = 0;
          if (activeCourse.length > 0) {
            courseId = activeCourse[0].courseId;
          } else {
            let latestCompleted = allInfo.tmsCourses.data.getTMSGetCourse.filter(
              (courseFilter: any) => courseFilter.status === "5"
            );
            courseId =
              latestCompleted.length > 0
                ? latestCompleted.sort((a: any, b: any) => b.courseId - a.courseId)[0].courseId
                : 0;
          }
          if (allInfo.common.productID)
            dispatch(
              allActions.currentCourseDetailsAction.getStoreActiveCourseInfo(
                allInfo.common.leuId,
                filteredSprintLevelLic[0].licenseId,
                filteredSprintLevelLic[0].productId,
                uuId,
                courseId
              )
            );
        }
      }
      
      if (allInfo.currentCourseDetails.data) {
        setLoaderFlag(false);
      }

      if (allInfo.currentCourseDetails.isFailed || (allInfo.tmsCourses.isFailed && !soloProducts.includes(allInfo.common.productID)) ||
        allInfo.peopleInformation.isFailed) {
        setLoaderFlag(false);
        dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
      }
    }
  }, [allInfo.peopleInformation, allInfo.currentCourseDetails, allInfo.tmsCourses]);

  useEffect(() => {
    if (allInfo.common.productID !== "") {
      const preworkCompletion = Math.round((props.cardData.prework / props.cardData.totalprework) * 100) ? Math.round((props.cardData.prework / props.cardData.totalprework) * 100) : 0;
      const homeWorkCompletion = Math.round((props.cardData.homework / props.cardData.totalhomework) * 100) ? Math.round((props.cardData.homework / props.cardData.totalhomework) * 100) : 0;
      const sessionCompletion = (100 * props.cardData.sessions) / props.cardData.totalsessions;

      if (preworkCompletion >= 70 && sessionCompletion >= 70) {
        if (allInfo.common.productID === "20" || (allInfo.common.productID === "18" && homeWorkCompletion >= 70)) setCertificateAvailability(true);
      }

      if(preworkCompletion >= 70 && soloProducts.filter((solo: any)=> solo === allInfo.common.productID).length > 0) {
        setCertificateAvailability(true);
      }

      if(allInfo.elevateAssessmentDetails.data && allInfo.common.productID === "25" && !sessionStorage.getItem("isDemoUser")) {
        let assessmentDetails = JSON.parse(allInfo.elevateAssessmentDetails.data.getElevateAssessmentDetails);
        if(assessmentDetails.length > 0) {
          let assessmentObj = assessmentDetails.find((partTitle: any) => (partTitle.title === `${props.cardData} Part ${props.partTitle} Progress Test`));
          if(assessmentObj && allInfo.elevateTestResult.testResults.length > 0) {
            let testResultStatus =  allInfo.elevateTestResult.testResults.find((testResult: any) => {
              return (testResult.TestContentId === assessmentObj.id)
            });
            if (testResultStatus && typeof testResultStatus === "object" && testResultStatus.Status === 2) {
              const userScore = testResultStatus.UserScore;
              const maxScore = testResultStatus.MaxScore;
              const results = Math.round((userScore / maxScore) * 100);
              if ((results >= Number(process.env.REACT_APP_CUTOFF_PERCENTAGE))) {
                setCertificateAvailability(true);
              }
            }
          }
        }
      }
    }
  }, [props, allInfo.common.productID]);

  useEffect(() => {
    if (!allInfo.tmsCourses.isLoading && !allInfo.tmsCourses.isFailed && !allInfo.tmsCourses.data) {
      const uuId = allInfo.common.luuId;
      dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
    }
  }, []);

  async function getCertificate(downloadCertificate: string, allInfo: any, part: any, downloadCertificateKey: string, dispatch: any, setLoaderFlag: any) {
    
    let productName = "";
    let url = "";
    setLoaderFlag(true);
    if(soloProducts.filter((solo: any)=> solo === allInfo.common.productID).length > 0 && !sessionStorage.getItem("isDemoUser")) {
      switch(allInfo.common.productID) {
        case "21" : productName = "solo_english"
        break;
        case "22" : productName = "solo_german"
        break;
        case "23" : productName = "solo_french"
        break;
        case "24" : productName = "solo_spanish"
        break;
        default : productName= ""
        break;
      }
      const data = await fetch(`${process.env.REACT_APP_BLOB_STORAGE}/content/${process.env.REACT_APP_ENV}/product_type/${productName}/default.json`).then(data => data.json());
  
      let courseId = data.level.filter((course: { title: string; }) => course.title == props.cardData.level)[0].courses[0].id;
      let licenseId = allInfo.peopleInformation.data.getpeopleInformation.license.filter((license: { productId: any; })=> license.productId === allInfo.common.productID)[0].licenseId|| "";
  
      url = `${downloadCertificate}?userId=${allInfo.peopleInformation.data.getpeopleInformation.edgeUid || ""}&courseId=${courseId}&licenseId=${licenseId}&part=${props.partTitle}&productId=${parseInt(allInfo.common.productID, 10)}`;
    } else if(allInfo.common.productID === "25") {
      url = `${downloadCertificate}?userId=${allInfo.currentCourseDetails.data.UserId || ""}&courseId=${props.cardData || ""}&licenseId=${allInfo.currentCourseDetails.data.LicenseId || ""}&part=${props.partTitle}&productId=${parseInt(allInfo.common.productID, 10)}`;
    } else {
      url = `${downloadCertificate}?userId=${allInfo.currentCourseDetails.data.UserId || ""}&courseId=${allInfo.currentCourseDetails.data.CourseId || ""}&licenseId=${allInfo.currentCourseDetails.data.LicenseId || ""}&part=${part}&productId=${parseInt(allInfo.common.productID, 10)}`;
    }
   
    if (sessionStorage.getItem("isDemoUser")) {
      url = `${downloadCertificate}?userId=${allInfo.peopleInformation.data.getpeopleInformation.edgeUid || ""}&courseId=${"6434118d-7376-47f5-b10a-87f3839d1979"}&licenseId=${"0"}&part=${`pilot:${moment().unix()}`}&productId=${parseInt((window.location.href.split("/")[4]), 10)}`;
    }
    const headers = {
      "x-api-key": downloadCertificateKey || "",
    };
  
    fetch(url, { headers }).then((res) => {
        return res.blob();
    }, (error) => (err: Error) => {
      setLoaderFlag(false);
      dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
    }).then((blob: any) => {
      const data = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = data;
      a.download = "Certificate.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setLoaderFlag(false);
      dispatch(allActions.toasterActions.showToastMessage(true, "success", "progress_certificate_download_success"));
    }, (error) => (err: Error) => {
      setLoaderFlag(false);
      dispatch(allActions.toasterActions.showToastMessage(true, "error", "message_errorDefault"));
    });
  }  

  const getCertificateImage = () => {
    switch (allInfo.common.productID) {
      case "18":
        return "sprint-skills-certificate-thumbnail.svg";
      case "20":
        return "sprint-english-certificate-thumbnail.svg";
      case "21":
        return "solo-english-certificate-thumbnail.svg";
      case "22":
        return "solo-german-certificate-thumbnail.svg";
      case "23":
        return "solo-french-certificate-thumbnail.svg";
      case "24":
        return "solo-spanish-certificate-thumbnail.svg";
      case "25":
        return "elevate-english-certificate-thumbnail.svg";
      case "26":
        return "sprint-german-certificate-thumbnail.svg";
      case "27":
        return "solo-french-certificate-thumbnail.svg";
      case "28":
        return "solo-spanish-certificate-thumbnail.svg";
      default:
        return "sprint-english-certificate-thumbnail.svg";
    }
  };

  return (
    <React.Fragment>
      <div className="certificate" onKeyDown={() => {}} onClick={() => !certificateAvailability && !sessionStorage.getItem("isDemoUser") ? setOpenDialog(true) : !loaderFlag && downloadCertificate() }>
        <div className="certificate-image">
          <img src={
            !certificateAvailability && !sessionStorage.getItem("isDemoUser")
              ? "../../../images/Certificate/certificate-placeholder.svg"
              : `../../../images/Certificate/${getCertificateImage()}`
            }
            alt="certificate"
          />
        </div>
        { !loaderFlag ? 
          <div className="certificate-lock">
            <img src={ !certificateAvailability && !sessionStorage.getItem("isDemoUser") ? 
                       "../../../images/cert-badge-lock.svg" : "../../../images/Certificate/certificate-download-icon.svg"
                      }
                      alt="badge"
            />
          </div>
        :
          <div className="certificate-loader">
            <CircularProgress size={16} color="primary" />
          </div>
        }
      </div>
      {openDialog && props.dialogContent && 
      <BadgesCertificatesDialogBox
        openDialog={openDialog}
        dialogContent={props.dialogContent}
        handleClose={handleClose}
        skill={props?.skill}
      />}
    </React.Fragment>
  );
};

export default CompletionCertificate;